<script>
    import utils from "@/utils.js";
    import { default as mojiCode } from "@/moji-codes.js";
    export default {
        name: "Emoji",
        props: {
            name: String
        },
        render(createElement) {
            if (process.env.NODE_ENV == "development") {
                return createElement("img", {
                    class: "emoji",
                    attrs: {
                        src: `${this.$store.state.apiRoot}emoji/${mojiCode(this.name)}`
                    }
                });
            } else {
                return createElement("svg", {class: "emoji"}, [
                    createElement("use", {
                        attrs: {
                            href: `#${this.name}`,
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": ""
                        }
                    })
                ]);
            }
        }
    };
</script>
